import React, {useState, useEffect} from 'react'
import {FaUndo, FaRedo, FaSave, FaPencilAlt, FaEraser} from 'react-icons/fa';
import '../App.css';
import useHover from '../utils/useHover'


function Button({btnText, onHandle, styles}) {
  const [bindHover, isHovered] = useHover();
  const [isDisabled, setIsDisabled] = useState(true)

  const selectIcon = (txt) => {
    switch(txt.toLowerCase()){
      case 'undo': return <FaUndo className='icon'/>;
      case 'redo': return <FaRedo className='icon'/>;
      case 'save': return <FaSave className='icon'/>;
      case 'draw': return <FaPencilAlt className='icon'/>;
      case 'clearall': return <FaEraser className='icon'/>;
      default: return null;
    }
  }

  const getStyle = () => {
    let btnStyles = 'button';
    let tmp_style = '';
    if (styles){
      tmp_style = styles
    }else{
      if(isHovered ){
        tmp_style = 'hovered';
      } else {
        tmp_style = 'normal';
      }
    }

    btnStyles += ' ' + tmp_style;
    // console.log(btnStyles)
    return btnStyles;
  }

  useEffect(() => {
    if(String(styles).indexOf("disabled") > -1){
      setIsDisabled(true)
    }else{
      setIsDisabled(false)
    }
  }, [styles])
  

  return (
      <button 
        {...bindHover} 
        className={getStyle()}
        onClick={onHandle}
        disabled={isDisabled}
      >
          {selectIcon(btnText)}
          {btnText}
      </button>
  )
}

export default Button
